import {
  type AudienceKind,
  type AudienceSeedDataGroup,
  type AudienceSeedOption,
  type DraftRuleBasedAudience,
} from "features/mediaDataRoom/models";

export type RulesBasedAudienceSeedOption = AudienceSeedOption;
export type RulesBasedAudienceRulesTree = DraftRuleBasedAudience;

export interface RulesBasedAudienceAudienceSizeFileStructure {
  audience_size: number;
}

export const seedOptionGroupPriority: Record<AudienceSeedDataGroup, number> = {
  Base: 0,
  Lookalike: 3,
  Remarketing: 2,
  "Rule-based": 4,
  Seed: 1,
};

export const mapAudienceKindToSeedOptionGroup: Record<
  AudienceKind,
  AudienceSeedDataGroup
> = {
  advertiser: "Remarketing",
  lookalike: "Lookalike",
  rulebased: "Rule-based",
};
